import { defineNuxtPlugin, useRuntimeConfig, useRouter } from "nuxt/app";
import posthogClient from "posthog-js";
import type { PostHog } from "posthog-js";

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const posthogToken = config.public.POSTHOG_TOKEN as string;
  const posthogHost = config.public.POSTHOG_HOST as string;

  let client: PostHog | null = null;

  if (posthogToken) {
    posthogClient.init(posthogToken, {
      api_host: posthogHost || "https://us.i.posthog.com",
      capture_pageview: false,
      capture_pageleave: true
    });
    client = posthogClient;

    const router = useRouter();

    // Register UTM params from initial landing as super properties
    const urlParams = new URLSearchParams(window.location.search);
    const utmSource = urlParams.get("utm_source");
    const utmMedium = urlParams.get("utm_medium");
    if (utmSource || utmMedium) {
      posthogClient.register({
        ...(utmSource && { utm_source: utmSource }),
        ...(utmMedium && { utm_medium: utmMedium })
      });
    }

    router.afterEach((to) => {
      posthogClient.capture("$pageview", { path: to.fullPath });
    });
  }

  return { provide: { posthog: client } };
});
